import * as angular from "angular";
import {IController} from "angular";
import {ConfigurationType} from "../../enums/configurationType.enum";

export class configurationProfilesTableRowCtrl implements IController {
  profile: any;
  type: string;
  onDuplicate: Function;
  onDelete: Function;
  onSetDefault: Function;

  public configurationType: typeof ConfigurationType = ConfigurationType;

  /* @ngInject */
  constructor() {}

  $onInit() {}

}
angular
  .module('bringoz.admin.configuration-profiles')
  .component('configurationProfilesTableRow', {
    bindings: {
      profile: '<',
      type: '<',
      onDuplicate: '&',
      onDelete: '&',
      onSetDefault: '&'
    },
    template: require('./configuration-profiles-table-row.html').default,
    controller: configurationProfilesTableRowCtrl
  });
